// extracted by mini-css-extract-plugin
module.exports = {"passed":"ProcessControlDetails-module__passed___16Gnz","evalutionCriteria":"ProcessControlDetails-module__evalutionCriteria___G8vhf"};